import React from 'react'

const ContainerFluid = ({children}) => {
    return (
        <div className="container-fluid">{children}</div>
    )
}

export default ContainerFluid